import React, { Component } from 'react';

let clientId;

switch (process.env.REACT_APP_TARGET) {
  case 'prod':
    clientId = 'kYAPEUagpvVUdtetoCkopdljRblzZGNcKIyUSXcK';
    break;
  case 'test':
    clientId = 'U68NYSUA1nybdBQlwMawPUGebR1lTJBzicVkVo2U';
    break;
  case 'dev':
    clientId = 'e9TdWbEDZSdf8iN20pFauOwj12HtiaXxzkmcT8gN';
    break;
  default:
    throw new Error(`Unkown target ${process.env.REACT_APP_TARGET}`);
}

const baseURL = 'https://accountview.net/';
const scope = 'readaccountviewdata';
const redirectUri = `${location.origin}/get-token.html`;
const loginUrl = `${baseURL}ams/authorize.aspx?response_type=token&client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}`;

class LoginPage extends Component {
  render() {
    return (
      <div>
        <a href={loginUrl} className="btn btn-primary btn-block">
          Login
        </a>
      </div>
    );
  }
}

export default LoginPage;



// WEBPACK FOOTER //
// ./src/auth/LoginPage.js